import { useEffect } from "react";

const OvenRepair = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#222222] text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {/* Image container with mobile optimization */}
        <div className="h-[40vh] md:h-screen relative">
          <img
            src="/lovable-uploads/ef128e50-c278-44dc-b162-50c2b5841ce0.png"
            alt="Oven repair service"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 overflow-y-auto">
          <h1 className="text-4xl font-bold mb-8 text-accent">Oven Repair Services</h1>
          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-accent-light mb-4">Professional Oven Repair in GTA</h2>
              <p className="text-gray-300 mb-4">
                We provide comprehensive oven repair services for all makes and models. Our experienced technicians
                ensure your oven is working safely and efficiently.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Our Services:</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Heating element replacement</li>
                <li>Temperature sensor repair</li>
                <li>Door hinge and seal repairs</li>
                <li>Control board diagnostics</li>
                <li>Thermostat calibration</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Service Benefits</h3>
              <ul className="space-y-4 text-gray-300">
                <li>✓ Expert technicians</li>
                <li>✓ Same-day service</li>
                <li>✓ Quality parts</li>
                <li>✓ Competitive rates</li>
                <li>✓ Warranty coverage</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Common Oven Issues</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-300">
                <div>• Not heating evenly</div>
                <div>• Temperature problems</div>
                <div>• Door not closing</div>
                <div>• Control panel issues</div>
                <div>• Self-cleaning problems</div>
                <div>• Strange noises</div>
              </div>
            </section>

            <div className="mt-8">
              <a
                href="tel:416-805-5075"
                className="bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-lg inline-block transition-colors"
              >
                Call Now for Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OvenRepair;
